import { z } from 'zod';
import { CurrencySchema, MoneyStringSchema } from './money';

export const API_KEY_SCOPES = ['tasks:create', 'tasks:read', 'assets:read', 'assets:write'] as const;
export type ApiKeyScope = (typeof API_KEY_SCOPES)[number];

export const API_KEY_STATUSES = ['active', 'disabled', 'expired', 'revoked'] as const;

export const CreateApiKeySchema = z.object({
  name: z.string().min(1).max(64),
  scopes: z.array(z.enum(API_KEY_SCOPES)).min(1),
  models: z.array(z.string()).default([]),
  total_limit: MoneyStringSchema,
  daily_limit: MoneyStringSchema.nullable().optional(),
  rpm_limit: z.number().int().positive().nullable().optional(),
  concurrency_limit: z.number().int().positive().nullable().optional(),
  expires_at: z.iso.datetime().nullable().optional(),
});
export type CreateApiKey = z.infer<typeof CreateApiKeySchema>;

// CreateApiKeySchema.models 带 .default([])；.partial() 下省略该字段仍会回填 []，而空数组被视为"放行所有已授权模型"，
// 会把部分更新意外地扩大权限（清空模型白名单）。重声明为可省略、无默认：省略时 updateKey 不触碰 model_ids。
export const UpdateApiKeySchema = CreateApiKeySchema.partial().extend({ models: z.array(z.string()).optional() });

export const ApiKeyObjectSchema = z.object({
  id: z.string(),
  object: z.literal('api_key'),
  name: z.string(),
  display: z.string(),
  scopes: z.array(z.enum(API_KEY_SCOPES)),
  models: z.array(z.string()),
  total_limit: z.string(),
  daily_limit: z.string().nullable(),
  used: z.string(),
  reserved: z.string(),
  rpm_limit: z.number().nullable(),
  concurrency_limit: z.number().nullable(),
  expires_at: z.string().nullable(),
  status: z.enum(API_KEY_STATUSES),
  last_used_at: z.string().nullable(),
  created_at: z.string(),
  currency: CurrencySchema,
  /** 控制台能否取回完整密钥（新建时加密保存过；早期创建的 Key 为 false） */
  revealable: z.boolean().default(false),
});
export type ApiKeyObject = z.infer<typeof ApiKeyObjectSchema>;

/** 仅创建时返回一次完整密钥 */
export const CreatedApiKeySchema = ApiKeyObjectSchema.extend({ secret: z.string() });
export type CreatedApiKey = z.infer<typeof CreatedApiKeySchema>;
